import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import StudentBioDataForm from "../components/biodata";
import "../assets/css/editprofile.css";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng"
  : "http://localhost:3003";

const EditProfile = () => {
  const [bioData, setBioData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const matricNo = localStorage.getItem("matricNo");

      if (!token || !matricNo) {
        setLoading(false);
        return;
      }

      try {
        const headers = { Authorization: `Bearer ${token}` };

        const [userRes, bioRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/users/${matricNo}`, { headers }),
          axios.get(`${API_BASE_URL}/api/biodata/${matricNo}`, { headers }).catch(() => ({
            data: null,
          })),
        ]);

        const user = userRes.data || {};
        const bio = bioRes.data || {};

        setBioData({
          ...bio,
          fullName: user.fullName || bio.fullName || "",
          email: user.email || bio.email || "",
          matricNumber: user.matricNo || bio.matricNumber || matricNo,
          department: user.programme || bio.department || "",
          CalenderYear: user.CalenderYear || bio.CalenderYear || bio.session || "",
          entryYear: user.entryYear || bio.entryYear || "",
          entryMode: user.entryMode || bio.entryMode || "",
          level: user.StudentLevel || bio.level || "",
          picture: bio.picture || null,
        });
      } catch (err) {
        console.error("Failed to load profile data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p style={{ padding: "2rem" }}>Loading...</p>;

  return (
    <div
      className="dashboard edit-profile-page"
      style={{ display: "flex", marginTop: "-120px" }}
    >
      <Sidebar />
      <div className="main-content">
        <StudentBioDataForm initialData={bioData} isEditMode={true} />
      </div>
    </div>
  );
};

export default EditProfile;